/**
 * @import { Feature, LineString } from 'geojson'
 */

/** @type {Feature<LineString>} */
export const emptyLineString = {
  type: 'Feature',
  geometry: {
    type: 'LineString',
    coordinates: [],
  },
  properties: {},
};
